import React, { useState, useRef, useEffect } from 'react';
import Transition from '../../utils/Transition';
import { useFetchIndustries } from '../../hooks/useCustomerJourney';
import { useFetchAllIndustriesList } from "../../hooks/useIndustry";

function FilterIndustries({ industriesType, setIndustriesType, filteredData, setFilteredData }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    // const [industriesType, setIndustriesType] = useState('');
    // const [filteredData, setFilteredData] = useState("");
    // Custom hook for fetching users
    const { data, error, isLoading } = useFetchAllIndustriesList();
    useEffect(() => { }, [filteredData])
    const trigger = useRef(null);
    const dropdown = useRef(null);

    // Filter industries based on search and industriesType

    useEffect(() => {
        console.log(industriesType)
        console.log(filteredData)

    }, [industriesType, filteredData])
    // Close on click outside
    useEffect(() => {
        const clickHandler = ({ target }) => {
            if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
            setDropdownOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // Close if the ESC key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }) => {
            if (!dropdownOpen || keyCode !== 27) return;
            setDropdownOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    const handleFilterChange = (event) => {
        setFilteredData(event.target.value); // Update the filter query as the user types
    };

    const handleindustriesTypeChange = (event) => {
        setIndustriesType(event.target.value); // Update the user type filter
    };



    return (
        <div className="relative inline-flex">
            <button
                ref={trigger}
                className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-500 hover:text-slate-600"
                aria-haspopup="true"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                aria-expanded={dropdownOpen}
            >
                <span className="sr-only">Filter</span>
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.5 16.5C6.36 16.5 3 13.14 3 9C3 4.86 6.36 1.5 10.5 1.5C14.64 1.5 18 4.86 18 9C18 13.14 14.64 16.5 10.5 16.5ZM10.5 3C7.42 3 5 5.42 5 9C5 12.58 7.42 15 10.5 15C13.58 15 16 12.58 16 9C16 5.42 13.58 3 10.5 3ZM21 21L16.5 16.5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            <Transition
                show={dropdownOpen}
                tag="div"
                className="origin-top-right z-10 absolute top-full left-0 right-auto md:left-auto md:right-0 min-w-56 bg-white border border-slate-200 pt-1.5 rounded shadow-lg overflow-hidden mt-1"
                enter="transition ease-out duration-200 transform"
                enterStart="opacity-0 -translate-y-2"
                enterEnd="opacity-100 translate-y-0"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
            >
                <div ref={dropdown}>
                    <div className="text-xs font-semibold text-slate-400 uppercase py-1.5 pb-2 px-4">Filters</div>

                    {/* Input fields for filtering by name */}
                    <div className="py-1 px-3">
                        <label className="flex items-center text-sm font-medium">
                            <input
                                type="text"
                                className="form-input w-full"
                                placeholder="Search name..."
                                value={filteredData}
                                onChange={handleFilterChange}
                            />
                        </label>
                    </div>
                    {/* User type filter */}
                    <div className="py-3 px-3">
                        <label className="flex items-center text-sm font-medium">
                            <select
                                className="form-select w-full"
                                value={industriesType}
                                onChange={handleindustriesTypeChange}
                            >
                                <option value="">All Industry</option>
                                {Array.isArray(data?.industry) && data.industry.map((industry) => (
                                    <option key={industry.name} value={industry.name}>
                                        {industry.name} 
                                    </option>
                                ))}


                            </select>
                        </label>
                    </div>
                </div>
            </Transition>

        </div>
    );
}

export default FilterIndustries;
